export default "__VITE_ASSET__B5t64F5N__"